<template>
  <div class="container-box">
    <template v-if="!$slots.header">
      <div class="box-header">
        <img class="icon" v-if="icon" :src="icon" alt="" />
        <img class="icon" v-else src="@/assets/nikke_imgs/box-header-icon.png" alt="" />
        <div class="title">{{ title }}</div>
      </div>
    </template>
    <template v-else>
      <slot name="header"></slot>
    </template>
    <div class="box-content">
      <slot></slot>
    </div>
    <div class="bottom-bg"></div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },

  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.container-box {
  position: relative;
  width: 100%;
  min-height: 100px;
  background-color: rgba(255, 255, 255, 0.8);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  backdrop-filter: blur(5px);
  border-radius: 8px 8px 8px 0;
  padding: 0 10px;
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
  .box-header {
    display: flex;
    align-items: center;
    padding: 10px 0;
    .icon {
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      margin-right: 5px;
    }
    .title {
      flex-shrink: 0;
      font-weight: bold;
      font-size: 16px;
      color: #333333;
      line-height: 19px;
      margin-right: 19px;
    }
    &::after {
      content: "";
      display: block;
      width: 100%;
      height: 1px;
      background: #d9dbe2;
    }
  }
  .box-content {
    padding: 10px 0 24px 0;
  }
  .bottom-bg {
    position: absolute;
    bottom: 10px;
    width: calc(100% - 20px);
    height: 19px;
    background: url("~@/assets/nikke_imgs/box-bottom-bg.png") no-repeat;
    background-size: 100% 100%;
  }
}
</style>
